export const DISCLOSURE_DROPDOWN_ITEM_NAME = 'GlDisclosureDropdownItem';
export const DISCLOSURE_DROPDOWN_GROUP_NAME = 'GlDisclosureDropdownGroup';
export const DISCLOSURE_DROPDOWN_GROUP_BORDER_POSITIONS = {
  top: 'top',
  bottom: 'bottom',
};
